
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 640"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M494.938 315.72l-32.81-36.38-36.37 32.81c-4.1 3.7-4.43 10.02-.73 14.12 3.7 4.11 10.02 4.43 14.13.73l11.72-10.57c-13.37 92.7-98.1 159.17-192 149.19-5.49-.6-10.41 3.39-11 8.88-.58 5.5 3.4 10.42 8.89 11 6.98.75 13.92 1.11 20.8 1.11 96.24 0 179.51-71.19 193.18-167.85l9.34 10.35a9.978 9.978 0 007.43 3.31c2.39 0 4.78-.85 6.69-2.58 4.1-3.7 4.43-10.02.73-14.12zM268.488 256.5v10h210v-10c0-48.49-33.04-89.41-77.79-101.42 20.01-10.01 33.79-30.72 33.79-54.58 0-33.64-27.37-61-61-61-33.64 0-61 27.36-61 61 0 23.86 13.77 44.56 33.78 54.58-44.75 12.02-77.78 52.93-77.78 101.42zM289.578 63.05l-32.01-37.08c-3.61-4.18-9.92-4.65-14.1-1.04-4.18 3.61-4.65 9.93-1.04 14.11l8.6 9.96c-105.5-7.8-198.67 70.44-208.74 176.24-.52 5.5 3.51 10.38 9.01 10.91.32.03.64.04.96.04 5.1 0 9.45-3.88 9.95-9.05 9.1-95.76 94.05-166.37 189.71-158l-12.49 10.78c-4.18 3.61-4.64 9.92-1.03 14.1a9.99 9.99 0 007.57 3.47c2.32 0 4.65-.8 6.53-2.43l37.08-32.01zM146.698 378.08c20.01-10.01 33.79-30.72 33.79-54.58 0-33.64-27.37-61-61-61-33.64 0-61 27.36-61 61 0 23.86 13.77 44.56 33.78 54.58-44.75 12.02-77.78 52.93-77.78 101.42v10h210v-10c0-48.49-33.04-89.41-77.79-101.42z"}})])
          )
        }
      }
    